import { State } from './activationRegistrationUIReducer'

interface ActivationState {
  // eslint-disable-next-line camelcase
  billing_package: string,
  // eslint-disable-next-line camelcase
  business_information: {
    // eslint-disable-next-line camelcase
    company_legal_name: string,
    // eslint-disable-next-line camelcase
    business_registration_number: string,
    // eslint-disable-next-line camelcase
    business_address: {
      city: string,
      state: string,
      country: string,
      // eslint-disable-next-line camelcase
      address_line: string,
      // eslint-disable-next-line camelcase
      zip_code: string
    }
  },
  // eslint-disable-next-line camelcase
  contact_information: {
    financial: string,
    development: string,
    business: string
  },
  // eslint-disable-next-line camelcase
  payment_method?: {
    // eslint-disable-next-line camelcase
    last_4_digits?: string
  }
}

export const mapActivationDataToActivationState = (stateToFill: State, activationData: ActivationState): State => {
  stateToFill.selectedPlan = activationData.billing_package

  stateToFill.businessInformation = {
    ...stateToFill.businessInformation,
    companyLegalName: activationData.business_information.company_legal_name,
    businessRegistrationNumber: activationData.business_information.business_registration_number
  }

  stateToFill.businessAddress = {
    ...stateToFill.businessAddress,
    city: activationData.business_information.business_address.city,
    state: activationData.business_information.business_address.state,
    country: activationData.business_information.business_address.country,
    addressLine1: activationData.business_information.business_address.address_line.split(', ')[0],
    addressLine2: activationData.business_information.business_address.address_line.split(', ')[1] || '',
    zipCode: activationData.business_information.business_address.zip_code
  }

  stateToFill.contactInformation = {
    ...stateToFill.contactInformation,
    financial: activationData.contact_information.financial,
    development: activationData.contact_information.development,
    business: activationData.contact_information.business
  }

  stateToFill.paymentInformation = {
    ...stateToFill.paymentInformation,
    last_4_digits: activationData?.payment_method?.last_4_digits || ''
  }
  return stateToFill
}
